<template>
    <div>

        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
            select-mode="single" selectable @row-selected="onRowSelected" show-empty>
            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay documentos que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha subido ningún documento
                </b-card>
            </template>
            <!--icono de carque de tabla-->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>

            </template>

            <!--botones de eliminar y editar -->
            <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                    <b-button
                        @click="openModalVerDocument()"
                        type="button"   
                        variant="outline-primary"
                        v-b-tooltip.hover="'Ver documento'"
                        size="sm"
                        class="me-2"
                    >      
                        <b-icon icon="eye-fill" font-scale="1"></b-icon>
                    </b-button>

                    <b-button
                        v-permission="'documentos-eliminar-documento'"
                        @click="openModalDelete()"
                        type="button"
                        variant="outline-danger"
                        v-b-tooltip.hover="'Eliminar documento'"
                        size="sm"
                        class="me-2"
                    >
                        <b-icon icon="trash-fill" font-scale="1"></b-icon>
                    </b-button>

                    <b-button
                        v-permission="'documentos-ver-vistas-documento'"
                        @click="openModalVistasUsuario()"
                        type="button"
                        variant="outline-success"
                        v-b-tooltip.hover="'Vistas del documento'"
                        size="sm"
                        class="me-2"
                    >
                        <b-icon icon="people-fill" font-scale="1"></b-icon>
                    </b-button>
                    
                    <b-button
                        v-permission="'documentos-ver-vistas-documento'"
                        @click="openModalNonVisitors()"
                        type="button"
                        variant="outline-secondary"
                        v-b-tooltip.hover="'Usuarios sin vistas'"
                        size="sm"
                        class="me-2"
                    >
                        <b-icon icon="person-x-fill" font-scale="1"></b-icon>
                    </b-button>
                </template>
                <template v-else>
                    <b-icon icon="three-dots" font-scale="1" class="icone-not-select"></b-icon>
                </template>
            </template>

            <!--boton de detalles -->
            <template #cell(detalle)="row">
                <b-button size="sm" @click="row.toggleDetails" variant="outline-secondary" class="mr-2">
                    <div v-if="row.detailsShowing">
                        <span class="d-none d-md-inline me-2">Ocultar</span>
                        <b-icon icon="eye-slash-fill" font-scale="1"></b-icon>
                    </div>
                    <div v-else>
                        <span class="d-none d-md-inline me-2">Ver</span>
                        <b-icon icon="eye-fill" font-scale="1"></b-icon>
                    </div>
                </b-button>
            </template>

            <!--cuerpo de detalle-->
            <template #row-details="row">
                <b-card>
                    <b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"><b>Destinatario</b></b-col>
                        <b-col>
                            <p v-bind:key="d.id" v-for="d in row.item.destinations">
                                {{ d.nombre + ' ' }}
                            </p>
                        </b-col>
                    </b-row>
                </b-card>
            </template>

        </b-table>

    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums/index.js'
import { applyDestinationFilter } from '@/plugins/complianceScripts/index.js'

export default {
    name: 'DocumentTable',

    data() {
        return {
            isBusy: false,
            items: [],
            selected: [],

            endDate: null,
            startDate: null,
            searchQuery: '',

            fields: [
                { key: 'nombre', label: 'Documento' },
                { key: 'confidencial', label: 'Confidencial' },
                { key: 'typeName', label: 'Tipo de documento'},
                {
                    key: 'creacionFormat',
                    label: 'Fecha creación',
                    formatter: (value) => {
                        return value;
                    }
                },
                { key: 'detalle', label: 'Detalle' },
                { key: 'selected', label: 'Opciones', thClass:"col-2"},
            ]
        }
    },

    components: {
        AlertDismiss
    },

    async mounted(){
        this.$eventBus.$on(EventNames.PaginationFilterDocument, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getAllDocument(page, pageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.CreateDocument, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getAllDocument(page, pageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterDocumentAfterSearch, (query) => {
            this.processingTable();

            this.searchQuery = query

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.DeleteDocument, async (query) => {
            this.processingTable();

            let page = query.page -1; 
            let pageSize = query.pageSize;

            await this.getAllDocument(page, pageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterDocumentName, (data) => {
            this.processingTable();

            let result = this.mapping(data);
            result = this.addTypeAccordingToId(result);
            this.items = result;

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterDocumenType, (data) => {
            this.processingTable();
            
            let result = this.mapping(data);
            result = this.addTypeAccordingToId(result)
            this.items = result;

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.ClearFilterDocumen, async (query) => {
            this.processingTable();

            let page = query.page -1; 
            let pageSize = query.pageSize;

            await this.getAllDocument(page, pageSize);

            this.processingTable();
        });
    },

    computed:{
        ...mapGetters(["getRole"]),

        filteredItems(){
            let filtered = this.items;

            // Filtrar por búsqueda por nombre, apellido, etc.
            if (this.searchQuery) {
                filtered = this.filterForSearch(filtered, this.searchQuery)
            }

            return filtered;
        }
    },

    methods:{
        ...mapActions(["allDocument", "getDocumentType"]),

        async getAllDocument(page, pageSize){
            this.items = []

            let documents = await this.allDocument({
                page: page,
                pageSize: pageSize,
                destination: applyDestinationFilter(this.getRole)
            });

            if (documents.isError) {
                this.$refs.alertDismiss.showAlert(documents.message);
                return;
            }

            let result = this.mapping(documents);
            result = this.addTypeAccordingToId(result)
            this.items.push(...result);
        },

        /*
            añade el nombre del tipo de documento segun el id,
            selecciona uno a uno los documentos y luego el añade el nombre del tipo de documento
         */
        addTypeAccordingToId(result){
            result.forEach(async document => {
                document.typeName = await this.getType(document.typeId);
            });

            return result;
        },

        processingTable() {
            this.isBusy = !this.isBusy
        },

        async getType(typeId){
            let type = await this.getDocumentType({
                id: typeId
            });

            if (type.isError) {
                this.$refs.alertDismiss.showAlert(type.message);
                return;
            }

            return type.data.name;
        },

        formatDate(date) {
            if (date == null) {
                return;
            }

            // Crear un objeto Date con la fecha y hora ISO
            var fechaHora = new Date(date);

            // Formatear la fecha y hora en un formato legible para el usuario
            var opcionesFormato = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            return fechaHora.toLocaleDateString('es-ES', opcionesFormato);
        },

        formatBoolean(value){
            if(value === true){
                return 'Si'
            }
            else{
                return 'No'
            }
        },

        filterForSearch(documentos, searchQuery) {
            const normalizedQuery = searchQuery.toLowerCase().trim();

            return documentos.filter(item =>
                Object.values(item).some(value =>
                    value.toString().toLowerCase().includes(normalizedQuery)
                )
            );
        },

        onRowSelected(items){
            this.selected = items;
        },

        openModalVerDocument(){
            this.$eventBus.$emit(EventNames.OpenModalDocumentLink, this.selected);
        },

        openModalDelete(){
            this.$eventBus.$emit(EventNames.OpenModalDocumentDelete, this.selected);
        },

        openModalVistasUsuario(){
            this.$eventBus.$emit(EventNames.OpenModalDocumentVisitors, this.selected);
        },

        openModalNonVisitors(){
            this.$eventBus.$emit(EventNames.OpenModalDocumentNonVisitors, this.selected);
        },

        mapping(documents){
            let result = documents.data.map((document) => {
                return {
                    id: document.id,
                    nombre: document.name,
                    typeId: document.typeId,
                    typeName: '',
                    confidencial: this.formatBoolean(document.confidential),
                    route: document.route,
                    creacionFormat: this.formatDate(document.creationDate) ?? '',
                    modificacionFormat: this.formatDate(document.dateLastModified) ?? '',
                    creacionDate: document.creationDate, //para el filtro
                    
                    destinations: document.rolesDestinations.map((d) => {
                        return {
                            id: d.id,
                            nombre: d.name
                        }
                    })
                }
            });

            return result;
        }
    }
    
}
</script>
<style>
    
</style>
